import PropTypes from 'prop-types';
import React from 'react';
import { Modal } from 'react-bootstrap';

import ModalBody from '../../atoms/ModalBody';
import ModalFotterCloseButton from '../../molecules/ModalFotterCloseButtonComponent';

class DeleteCompleteModal extends React.Component {
  static get propTypes() {
    return {
      show: PropTypes.bool,
      onClick: PropTypes.func,
    };
  }

  render() {
    return (
      <Modal show={this.props.show}>
        <ModalBody>
          <p className="text-center">正常に削除が行われました。</p>
        </ModalBody>
        <ModalFotterCloseButton
          closeButtonTitle="閉じる"
          onClick={this.props.onClick}
        />
      </Modal>
    );
  }
}

export default DeleteCompleteModal;
